import { render } from "./LiveGridPagination.vue?vue&type=template&id=f74cf898"
import script from "./LiveGridPagination.vue?vue&type=script&lang=js"
export * from "./LiveGridPagination.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__